import { LoginRepository } from '@/Account/domain/LoginRepository'
import { LoginModel } from '@/Account/domain/LoginModel'
import { HttpMethod, HttpModel } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import { resendOtpCode, login, validateOtpCode } from '@/Shared/infrastructure/endpoints'
import { LoginForm } from '../ui/hooks'

export function createLoginRepository(): LoginRepository {
  return new ApiLoginRepository()
}

export const merchantUserProfile = 3

type LoginApiForm = {
  username: string
  password: string
  browser: string
}

const convertFormToApi = (form: LoginForm): LoginApiForm => ({
  username: form.username,
  password: form.password,
  browser: window.navigator.userAgent
})

export class ApiLoginRepository implements LoginRepository {
  async Login(data: LoginForm): Promise<HttpModel<LoginModel>> {

    const response = await axiosFetch(login, HttpMethod.POST, convertFormToApi(data))

    if (!response.data) {
      return {
        data: {} as LoginModel,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async ValidateOtp(otp: string, guid: string): Promise<HttpModel<boolean>> {
    return await axiosFetch(validateOtpCode, HttpMethod.POST, {
      otp,
      guid,
    })
  }

  async ResendOtp(): Promise<HttpModel<string>> {
    return await axiosFetch(resendOtpCode, HttpMethod.POST, {
      userProfile: merchantUserProfile
    })
  }
}
